import React, { useEffect } from "react";

/**
 * <DocumentTitle title="…" /> — sets document.title for the current route.
 * Msg 73 point flagged: /app was inheriting the index.html title
 * "watu wako · admin desk". Each surface owns its own title.
 */
export default function DocumentTitle({ title }) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => { document.title = prev; };
  }, [title]);
  return null;
}
